<template>
  <svg
    v-if="isOpen"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="21"
    viewBox="0 0 20 21"
  >
    <g fill="none" fill-rule="evenodd">
      <g fill="#D2D6E2">
        <g>
          <g>
            <g>
              <path
                d="M14.12 5.265c0-.851-.217-1.652-.598-2.35 1.082.653 2.022 1.542 2.733 2.621-.844 1.281-2.01 2.294-3.353 2.961.756-.865 1.218-1.995 1.218-3.232zM4.968 2.752c-.44.737-.698 1.594-.698 2.513 0 1.312.519 2.5 1.357 3.384-1.477-.66-2.763-1.73-3.674-3.113.773-1.172 1.815-2.12 3.015-2.784zm.98 2.513c0-1.791 1.456-3.248 3.248-3.248 1.79 0 3.248 1.457 3.248 3.248 0 1.791-1.457 3.248-3.248 3.248-1.792 0-3.249-1.457-3.249-3.248zm12.018-.148C16.139 1.96 12.744 0 9.105 0 5.465 0 2.07 1.96.243 5.117L0 5.537l.243.42c1.827 3.155 5.222 5.116 8.862 5.116 3.639 0 7.034-1.96 8.861-5.117l.243-.42-.243-.42z"
                transform="translate(-926 -324) translate(470 309) translate(456 15) translate(.833 4.167)"
              />
              <path
                d="M9.105 6.57c-.757 0-1.37-.613-1.37-1.369s.614-1.369 1.37-1.369c.755 0 1.369.613 1.369 1.37 0 .755-.614 1.368-1.37 1.368z"
                transform="translate(-926 -324) translate(470 309) translate(456 15) translate(.833 4.167)"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
  <svg
    v-else
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="21"
    viewBox="0 0 20 21"
  >
    <g fill="none" fill-rule="evenodd">
      <g>
        <g>
          <g>
            <g>
              <path
                fill="#E1F5FE"
                d="M.703 5.536c2.89-3.121 5.69-4.61 8.402-4.468 2.71.142 5.475 1.687 8.29 4.633-2.248 3.196-5.078 4.794-8.489 4.794-3.41 0-6.145-1.653-8.203-4.959z"
                transform="translate(-926 -264) translate(470 249) translate(456 15) translate(.833 4.167)"
              />
              <path
                fill="#164194"
                d="M14.12 5.265c0-.851-.217-1.652-.598-2.35 1.082.653 2.022 1.542 2.733 2.621-.844 1.281-2.01 2.294-3.353 2.961.756-.865 1.218-1.995 1.218-3.232zM4.968 2.752c-.44.737-.698 1.594-.698 2.513 0 1.312.519 2.5 1.357 3.384-1.477-.66-2.763-1.73-3.674-3.113.773-1.172 1.815-2.12 3.015-2.784zm.98 2.513c0-1.791 1.456-3.248 3.248-3.248 1.79 0 3.248 1.457 3.248 3.248 0 1.791-1.457 3.248-3.248 3.248-1.792 0-3.249-1.457-3.249-3.248zm12.018-.148C16.139 1.96 12.744 0 9.105 0 5.465 0 2.07 1.96.243 5.117L0 5.537l.243.42c1.827 3.155 5.222 5.116 8.862 5.116 3.639 0 7.034-1.96 8.861-5.117l.243-.42-.243-.42z"
                transform="translate(-926 -264) translate(470 249) translate(456 15) translate(.833 4.167)"
              />
              <path
                fill="#13A2E8"
                d="M9.105 6.57c-.757 0-1.37-.613-1.37-1.369s.614-1.369 1.37-1.369c.755 0 1.369.613 1.369 1.37 0 .755-.614 1.368-1.37 1.368z"
                transform="translate(-926 -264) translate(470 249) translate(456 15) translate(.833 4.167)"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
};
</script>